import type { CreateTweetJsonBodyMediaItem } from './createTweetJsonBodyMediaItem';
import type { CreateTweetJsonBodyPoll } from './createTweetJsonBodyPoll';
import type { CreateTweetJsonBodyTweetType } from './createTweetJsonBodyTweetType';

export type CreateTweetJsonBody = {
  media?: CreateTweetJsonBodyMediaItem[];
  /** @nullable */
  poll?: CreateTweetJsonBodyPoll;
  /**
   * Required for REPLY and QUOTE types
   * @nullable
   */
  referenceTweetId?: string | null;
  /**
   * Tweet text content
   * @maxLength 280
   * @nullable
   */
  text?: string | null;
  /** @nullable */
  tweetType?: CreateTweetJsonBodyTweetType;
};
